<template>
  <div class="app-container pull-auto notice-list">
    <div class="notice-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="notice-list-filter-value full-screen" v-model.trim="listQuery.noticeContent" clearable placeholder="内容" size="small"></el-input>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="notice-list-filter-value" placeholder="类型"
                v-model="listQuery.noticeType" clearable size="small">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col> -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="notice-list-filter-value" v-model.trim="listQuery.noticeToName" placeholder="接收者"
                clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="notice-list-filter-date"
              v-model="listQuery.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <el-button class="notice-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
          <el-button class="notice-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
        </el-col>
      </el-row>
    </div>

    <basic-container>
      <avue-crud
          ref="noticeCrud"
          :page="noticePage"
          :data="noticeTableData"
          :table-loading="noticeTableLoading"
          :option="tableOption"
          @row-update="handleUpdated"
          @current-change="noticeCurrentChange"
          @size-change="noticeSizeChange">
        <template slot="menuLeft">
          <el-button type="primary"
            @click="handleAdd"
            icon="el-icon-add"
            size="small" v-if="permissions.msg_add">创建消息</el-button>
          <br /><br />
        </template>

        <template slot="link"
          slot-scope="scope">
            {{scope.row.link || '--'}}
        </template>

        <template slot="noticeToName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.noticeTo);"
            class="notice-list-container-button">
            {{scope.row.noticeToName}}</a>
        </template>

        <template slot="entity"
                  slot-scope="scope">
            <span v-if="scope.row.entityId!= null">
              <a href="javascript:void(0);" @click="toLinkPage(scope.row.entityType, scope.row.entityId);"
                class="notice-list-container-button">
                {{scope.row.entity}}</a>
            </span>
            <span v-else>--</span>
        </template>

        <template slot="isSendWxCpNews"
                  slot-scope="scope">
            <span>
              {{scope.row.isSendWxCpNews !== null && scope.row.isSendWxCpNews ? '是' : '否'}}
            </span>
        </template>

        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                v-if="permissions.msg_update && scope.row.canEdit"
                type="text"
                icon="icon-edit"
                title="编辑"
                @click="handleUpdate(scope.row,scope.index)">
          </el-button>
          <el-button type="text"
            v-if="permissions.msg_delete"
            icon="icon-delete"
            size="mini"
            title="删除"
            @click="handleDeleted(scope.row,scope.index)"></el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { fetchList, updateMsg, deleteMsg } from '@/api/msg/notice'
  import { noticeTableOption } from '@/const/crud/msg/notice'
  import { mapGetters } from 'vuex'
  import template from 'lodash/template';
  import noticeTypeEnum from './enums/noticeTypeEnum';
  import entityTypeEnum from './enums/entityTypeEnum';
  import noticeToTypeEnum from './enums/noticeToTypeEnum';

  export default {
    name: 'notice',
    data() {
      return {
        // 搜索功能
        typeOptions: Object.values(noticeTypeEnum),
        listQuery: {
          current: 1,
          size: 10,
          noticeContent: "",
          noticeType: undefined,
          noticeToName: "",
          searchTime: [],
        },

        // 列表页面
        noticeTableData: [],
        noticePage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        noticeTableOption,
        noticeTableLoading: false,
      }
    },
    created() {
      this.getList()
    },
    mounted: function() { },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.listQuery.searchTime && this.listQuery.searchTime.length > 0) {
          return this.listQuery.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.listQuery.searchTime && this.listQuery.searchTime.length > 1) {
          return this.listQuery.searchTime[1]
        } else {
          return null
        }
      },
      tableOption() {
        let permissons = this.permissions;

        const cloneOption = Object.freeze(noticeTableOption);

        if (permissons.msg_update) {
          cloneOption.editBtn = false;
          cloneOption.menu = true;
        }

        if (permissons.msg_delete){
          cloneOption.delBtn = false;
          cloneOption.menu = true;
        }

        return cloneOption;
      }
    },
    methods: {
      handleUpdate(row, index) {
        this.$refs.noticeCrud.rowEdit(row, index);
      },
      handleAdd () {
        this.$router.push({
          path: '/msg/notice/add'
        })
      },
      async handleUpdated (post, index, done, loading) {
        if (!post || !post.id) {
          return;
        }

        if (!post.noticeContent || !post.noticeContent.trim()) {
          return;
        }
        const params = {
          id: post.id,
          noticeContent: post.noticeContent,
          link: post.link,
          noticeToType: 2, // 1：个人，2：所有
          isSendWxCpNews: post.isSendWxCpNews,
        }
        const response = await this.requestWrapper(updateMsg, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: '更新失败',
            type: 'error',
          });
          loading();
          return;
        }

        this.getList();
        this.$message({
          showClose: true,
          message: '更新成功',
          type: 'success',
        });
        done();
      },
      async handleDeleted (post) {
        if (!post || !post.id) {
          return;
        }

        var _this = this;
        this.$confirm('是否确认删除ID为' + post.id + '的消息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async function () {
          const params = {
            id: post.id
          }
          const response = await _this.requestWrapper(deleteMsg, params)
          if (!response || response.ok === false) {
            this.$message({
              showClose: true,
              message: '删除失败',
              type: 'error',
            });
            return;
          }

          await _this.getList();
          if (_this.noticeTableData.length === 0 && _this.listQuery.current > 1) {
            _this.listQuery.current -= 1;
            _this.getList();
          }
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        });
      },
      formatData(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            record.noticeTypeId = record.noticeType;
            // 系统消息类别格式化
            const noticeType = Object.values(noticeTypeEnum).find(item => item.value === record.noticeType);
            record.noticeType = noticeType ? noticeType.label : '--';
            record.canEdit = record.noticeTypeId === noticeTypeEnum.SYSTEM.value
                              && (record.isSendWxCpNews === null || !record.isSendWxCpNews);

            const noticeToType = Object.values(noticeToTypeEnum).find(item => item.value === record.noticeToType);
            record.noticeToTypeName = noticeToType ? noticeToType.label: '--';

            // 关联事务ID格式化
            if (record.entityType != null) {
              if (record.entityId != null && record.entityId != "") {
                const entityType = Object.values(entityTypeEnum).find(item => item.value === record.entityType);
                record.entity = entityType ? (entityType.label + record.entityId) : '--';
              } else {
                record.entity = "--"
              }
            } else {
              record.entity = "--"
            }
            if (record.noticeToName == null || record.noticeToName == '') {
              record.noticeToName = "--"
            }
            // 消息内容格式化
            try {
              const noticeContent = JSON.parse(record.noticeContent);
              if (noticeContent.template) {
                noticeContent.template = noticeContent.template.replace(/\$\{/g, '<%-');
                noticeContent.template = noticeContent.template.replace(/\}/g, '%>');
                const compiled = template(noticeContent.template);
                if (record.noticeTypeId === noticeTypeEnum.POST_COMMENT.value) {
                  noticeContent.template = compiled({
                    memberName: `${noticeContent.memberName} `,
                    postTitle: `${noticeContent.postTitle}`,
                  });
                } else if (record.noticeTypeId === noticeTypeEnum.POST_COMMENT_REPLY.value) {
                  noticeContent.template = compiled({
                    memberName: `${noticeContent.memberName} `,
                    comment: `${noticeContent.comment}`,
                  });
                } else if ([noticeTypeEnum.POST_UP.value, noticeTypeEnum.POST_REMOVED.value].indexOf(record.noticeTypeId) !== -1) {
                  noticeContent.template = compiled({
                    postTime: ` ${noticeContent.postTime} `,
                    postTitle: `${noticeContent.postTitle}`,
                    banComment: `${noticeContent.banComment}`,
                  });
                } else if ([noticeTypeEnum.COMMENT_UP.value, noticeTypeEnum.COMMENT_REMOVED.value].indexOf(record.noticeTypeId) !== -1) {
                  noticeContent.template = compiled({
                    commentTime: ` ${noticeContent.commentTime} `,
                    comment: `${noticeContent.comment}`,
                    banComment: `${noticeContent.banComment}`,
                  });
                } else if (record.noticeTypeId === noticeTypeEnum.POST_EXPIRED.value) {
                  noticeContent.template = compiled({
                    postTime: ` ${noticeContent.postTime} `,
                    postTitle: `${noticeContent.postTitle}`,
                  });
                }
                record.link = noticeContent.link;
                record.noticeContent = noticeContent.template;
              } else if (record.noticeTypeId === noticeTypeEnum.POST_COMMENT.value) {
                record.noticeContent = `${noticeContent.memberName}评论了你的帖子`;
              }
            } catch (error) {
              console.error(error);
            }
          })
        }
        return records
      },
      async getList() {
        // 获取系统消息列表
        let params = {
          current: this.listQuery.current,
          size: this.listQuery.size
        }
        // 增加搜索功能
        if (this.listQuery.noticeContent != "" && this.listQuery.noticeContent.trim() != "")
          params.noticeContent = this.listQuery.noticeContent
        if (this.listQuery.noticeType != null )
          params.noticeType = this.listQuery.noticeType
        if (this.listQuery.noticeToName != "" && this.listQuery.noticeToName.trim() != "")
          params.noticeToName = this.listQuery.noticeToName
        if (this.startTime && this.endTime) {
          params.sentStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.sentEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.sentStartTime = null
          params.sentEndTime = null
        }
        // for mc-web#204 - 后台消息页面，除系统消息外，其他类型的消息需隐藏
        params.noticeType = noticeTypeEnum.SYSTEM.value;

        this.noticeTableLoading = true
        const response = await this.requestWrapper(fetchList, params);
        this.noticeTableData = this.formatData(response.data.records)
        this.noticePage.total = response.data.total
        this.noticeTableLoading = false
      },
      noticeCurrentChange(val) {
        this.noticePage.current = val
        this.listQuery.current = val
        this.getList()
      },
      noticeSizeChange(val) {
        this.noticePage.size = val
        this.listQuery.size = val
        this.getList()
      },
      initPage() {
        this.noticePage.currentPage = 1
        this.noticePage.pageSize = this.listQuery.size
        this.listQuery.current = 1
        this.listQuery.sortField = ""
        this.listQuery.sortPolicy = ""
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.listQuery.noticeContent = ""
        this.listQuery.noticeType = ""
        this.listQuery.noticeToName = ""
        this.listQuery.searchTime = []
        this.searchChange()
      },

      toLinkPage(entityType, entityId) {

        let pagePath = ''
        if (entityType == 0) { pagePath = "/post/posts/detail/" + entityId}
        else if (entityType == 1) { pagePath = "/post/essay/detail/" + + entityId }
        else if (entityType == 2) { pagePath = "/post/circle/detail/" + + entityId }
        else if (entityType == 3) { pagePath = "/post/column/detail/" + + entityId }
        else if (entityType == 4) { pagePath = "/post/circle/detail/" + + entityId }
        else if (entityType == 5) { pagePath = "/upms/member/detail/" + + entityId }

        this.$router.push({
          path: pagePath,
        })
      },
      toMemberDetail(noticeToId) {
        // 列表里点击接收者，链接转到该接收者的会员详情
        if (noticeToId < 1) {
          return;
        }

        this.$router.push({
          path: "/upms/member/detail/" + noticeToId,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.notice-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-date {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      float: right;
      margin-right: 8px;
    }
    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
